import React from 'react'
import { api } from 'core/api/ConnectionManager'
import moment, { Moment } from 'moment'
import translate from 'core/translate'
import { routes } from 'features/routes'
import { defaultThemeStyles } from './dashboard__network.theme'
import { changeLocation } from 'features/routes'

const incoming = `var(--var-module-dashboard-component-network-style-incoming, ${defaultThemeStyles.incoming})`
const outgoing = `var(--var-module-dashboard-component-network-style-outgoing, ${defaultThemeStyles.outgoing})`

export interface IDashboardNetworkProps {
    className?: string
    rules?: {
        order?: number
    }
}

export interface IDashboardNetworkDataItem {
    label: string
    value: number
}

type DashboardNetworkDate = Moment | string

interface IDashboardNetworkState {
    data: IDashboardNetworkDataItem[]
    isLoaded: boolean
    isOpenReportModal: boolean
    startDate: DashboardNetworkDate
    endDate: DashboardNetworkDate
}

type TodayNetStatResponse = Partial<Record<'received' | 'transmitted', number>>

interface ICreateReportTaskRequest {
    startDate: string
    endDate: string
    reportType: 'serverNetStatReport'
}

class DashboardNetworkMethods extends React.PureComponent<IDashboardNetworkProps, IDashboardNetworkState> {
    state: IDashboardNetworkState = {
        data: [],
        isLoaded: false,
        isOpenReportModal: false,
        startDate: moment(),
        endDate: moment(),
    }

    colors = [incoming, outgoing]

    componentDidMount() {
        api.send<object, TodayNetStatResponse | null>('getTodayNetStat', {}, { showEmitError: false }).then((res) => {
            if (!res) {
                return
            }

            const dataFields = ['received', 'transmitted'] as const
            const data = dataFields.reduce<IDashboardNetworkDataItem[]>((items, key) => {
                const value = res[key]

                if (typeof value === 'number') {
                    items.push({ label: translate(key), value })
                }

                return items
            }, [])

            this.setState({ data, isLoaded: true })
        })
    }

    onCreateReport = () => {
        const s_ = this.state
        const startDate = moment(s_.startDate).format('YYYY-MM-DD')
        const endDate = moment(s_.endDate).format('YYYY-MM-DD')

        api.send<ICreateReportTaskRequest, unknown>('createReportTask', {
            startDate,
            endDate,
            reportType: 'serverNetStatReport',
        }).then(() => {
            this.setState({ isOpenReportModal: false }, () => {
                changeLocation(`/${routes.reportTasks.path}`)
            })
        })
    }
}

export default DashboardNetworkMethods
